import { useState } from "react";
import RevenueBySales from "./components/RevenueBySales";
import RevenueSummary from "./components/RevenueSummary";
import RevenueByOprt from "./components/RevenueByOprt";
import { Button, Checkbox, DatePicker, Form } from "antd";
import moment from "moment";
import { RiFilterOffLine } from "react-icons/ri";
import TechnicianEfficiency from "./components/TechnicianEfficiency";
import RevenueBreakdown from "./components/RevenueBreakdown";
import DateLine from "../../components/shared/DateLine";
import RevenueDept from "./components/RevenueDept";
import AutolineNote from "../../components/shared/AutolineNote";
import PageHeader from "../../components/shared/PageHeader";
import { Popover as ManPopover } from "@mantine/core";
import { FiCreditCard } from "react-icons/fi";
import { BsChevronDown } from "react-icons/bs";
import { useNavigate } from "react-router";
import Workshop from "./Workshop";
import Parts from "./Parts";

const { RangePicker } = DatePicker;

export default function Revenues() {
  const [startDate, setStateDate] = useState(
    moment(new Date()).format("YYYYMMDD")
  );
  const [endDate, setEndDate] = useState(moment(new Date()).format("YYYYMMDD"));
  const [showRange, setShowRange] = useState(false);

  const [form] = Form.useForm();
  const [opened, setOpened] = useState(false);
  const [type, setType] = useState({
    id: 1,
    name: "Workshop Revenue",
    link: "/revenues/workshop",
  });

  const navigate = useNavigate();

  const onDateChange = (date: any) => {
    setStateDate(moment(new Date(date)).format("YYYYMMDD"));
    setEndDate(moment(new Date(date)).format("YYYYMMDD"));
  };

  const onRangeChange = (date: any) => {
    setStateDate(moment(new Date(date[0])).format("YYYYMMDD"));
    setEndDate(moment(new Date(date[1])).format("YYYYMMDD"));
  };

  const clearDate = () => {
    form.resetFields();
    setStateDate(moment(new Date()).format("YYYYMMDD"));
    setEndDate(moment(new Date()).format("YYYYMMDD"));
  };

  const pages = [
    { id: 1, name: "Workshop Revenue", link: "/revenues/workshop" },
    { id: 2, name: "Parts Revenue", link: "/revenues/parts" },
  ];

  return (
    <div className=" bg-gray-100">
      <AutolineNote />
      <div className="flex flex-col border border-gray-300 mx-4 rounded-lg mt-2 bg-white">
        <PageHeader
          title={`${type.name}`}
          subtitle={`Different categories of revenue`}
          tag={`Analysis`}
          actions={
            <div className="flex flex-row">
              <div className="flex flex-row items-center">
                <div className="text-white">
                  <ManPopover
                    className="cursor:pointer focus:outline-none bg-red-100  hover:text-white"
                    opened={opened}
                    onClose={() => setOpened(false)}
                    target={
                      <div
                        onClick={() => setOpened((o) => !o)}
                        className="border border-gray-300  py-2 px-2 cursor-pointer"
                      >
                        <div className="flex flex-row justify-between items-center bg-red-100 text-black hover:text-red-800">
                          <div className="flex justify-center items-center">
                            <FiCreditCard />
                            <span className="ml-2 trancate ">{type?.name}</span>
                          </div>
                          <div className="ml-2">
                            <BsChevronDown color={"#323232"} />
                          </div>
                        </div>
                      </div>
                    }
                    width={260}
                    position="bottom"
                    withArrow
                  >
                    <div className="flex flex-col">
                      {pages?.map((page: any) => (
                        <button
                          className="cursor-pointer hover:text-toyota text-left focus:outline-none py-2"
                          onClick={() => {
                            // navigate(page.link);
                            setType(page);
                            setOpened((o) => !o);
                          }}
                          key={page?.id}
                        >
                          {page?.name}
                        </button>
                      ))}
                    </div>
                  </ManPopover>
                </div>
              </div>
            </div>
          }
        />
        {type.id === 1 ? (
          <div className="">
            <Workshop />
          </div>
        ) : (
          <div className="">
            <Parts />
          </div>
        )}
      </div>
    </div>
  );
}
